import { qs, qsa } from './utils.js';
import { bindBookButtonsValidation, bindClientFormValidation } from './validation.js';
import { pickCurrentPrice } from './prices.js';
import { state } from './state.js';
import { CFG } from './config.js';
import { initClickTimeSlots, verifyMilID, showLoading, hideLoading, showAlert, checkEmailExists } from './api.js';
import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';
import { initCalendar } from './calendar.js';


function getRateLabelByTrigger (triggerBtn) {
    const row = triggerBtn?.closest('.book__pricesRow');
    if (!row) return '';
    const priceBox = row.querySelector('.book__price');
    const visible = priceBox?.querySelector('.is-visible');
    if (!visible) return '';
    return visible.hasAttribute('data-veteran-rates') ? 'Veteran' : 'Standard';
}

function formatLongDate (date) {
    if (!(date instanceof Date)) return '';
    const opts = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return new Intl.DateTimeFormat('en-US', opts).format(date);
}

function getSelectedTime (container) {
    const checked = container.querySelector('.book__calendarItems input[type="radio"]:checked');
    if (!checked) return '';
    const label = container.querySelector(`label[for="${checked.id}"]`);
    return label ? label.textContent.trim() : '';
}

function getPatientTypeLabel (container, patientDropdownId) {
    const dd = qs(container, patientDropdownId);
    const selected = dd?.querySelector('[data-selected]');
    return selected ? selected.textContent.trim() : '';
}

function getPlanNameByTrigger (triggerBtn) {
    const row = triggerBtn?.closest('.book__pricesRow');
    const titleEl = row?.querySelector('.book__pricesCol:first-child h6');
    const raw = titleEl ? titleEl.textContent.trim() : '';
    return raw.replace(/^Service\s*-\s*/i, '');
}

function getVisiblePriceFromRow (triggerBtn) {
    const row = triggerBtn?.closest('.book__pricesRow');
    if (!row) return '';
    const priceBox = row.querySelector('.book__price');
    if (!priceBox) return '';
    const visible = priceBox.querySelector('.is-visible');
    return visible ? visible.textContent.trim() : '';
}

function fillPaymentSummary (container, { triggerBtnForPlan }) {
    const payment = qs(container, '[data-payment]');
    if (!payment) return;

    const parseCents = (text) => {
        if (!text) return null;
        const num = Number(text.replace(/[^0-9.]/g, ''));
        return Number.isNaN(num) ? null : Math.round(num * 100);
    };

    const dd = qs(container, CFG.ids.patientDd);
    const selected = dd?.querySelector('[data-selected]');
    const patientLabel = selected ? selected.textContent.trim() : '';
    payment.querySelector('.book__paymentInfo p:nth-child(1) strong').textContent = patientLabel || '—';

    state.plan = getPlanNameByTrigger(triggerBtnForPlan) || state.plan;
    const planP = payment.querySelector('.book__paymentInfo p:nth-child(2)');
    const { mode } = pickCurrentPrice(container);
    console.log('fillPaymentSummary: picked price mode=', mode);
    const rateLabel = mode === 'veteran' ? 'Veteran ' : (mode === 'standard' ? 'Standard ' : '');
    planP.textContent = state.plan ? `${rateLabel}${state.plan} Plan` : '—';
    // set plan to id payment-plan
    const planIdEl = payment.querySelector('#payment-plan');
    if (planIdEl) {
        planIdEl.textContent = state.plan ? `${rateLabel}${state.plan} Plan` : '—';
    }

    const calEl = qs(container, CFG.selectors.calendar);
    const dp = calEl?._airdp;
    const date = dp?.selectedDates?.[0] || null;
    const time = getSelectedTime(container);
    state.dateISO = date ? new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toISOString().slice(0, 10) : null;
    state.timeSlot = time || state.timeSlot;

    const dateTimeP = payment.querySelector('.book__paymentInfo p:nth-child(3)');
    const dateTxt = date ? formatLongDate(date) : '';
    const timeTxt = state.timeSlot || '';
    dateTimeP.textContent = (timeTxt && dateTxt) ? `${timeTxt} - ${dateTxt}` : (timeTxt || dateTxt || '—');

    const planRow = triggerBtnForPlan?.closest('.book__pricesRow');
    const priceBox = planRow?.querySelector('.book__price');
    const visible = priceBox?.querySelector('.is-visible');
   // const priceTxt = visible ? visible.textContent.trim() : null;
   // state.priceText = priceTxt;
   // state.priceCents = parseCents(priceTxt);

   // const totalSpan = payment.querySelector('.book__paymentFormTotalRight .fw-bold');
    //totalSpan.textContent = state.priceText || '—';

        let isPaymentInitialized = false;
        let isPaymentInitializing = false; // Флаг для запобігання паралельним викликам
        let card = null;

        const stepPayment = qs(container, '[data-payment]');

        // Initialize Square Web Payments SDK
        async function initSquarePayment() {
            if (!window.Square) {
                throw new Error('Square.js failed to load properly');
            }

            // if (isPaymentInitialized || isPaymentInitializing) {
            //     console.log('initSquarePayment. Payment already initialized or initializing, skipping ...');
            //     return;
            // }

            // Get application ID from meta tag or config
            const appId = document.querySelector('meta[name="square-app-id"]')?.content || 'sandbox-sq0idb-YOUR_APP_ID';
            const locationId = document.querySelector('meta[name="square-location-id"]')?.content || 'YOUR_LOCATION_ID';

            console.log('Initializing Square payment with appId:', appId, 'locationId:', locationId);

            const payments = window.Square.payments(appId, locationId);
            isPaymentInitializing = true; 

            // hide #paymentLoader
            const paymentLoader = document.querySelector('#paymentLoader'); 
            if (paymentLoader) {
                paymentLoader.style.display = 'none';
            }
            
            // Initialize card payment
            card = await payments.card();
            await card.attach('#card-container');
            
            console.log('Square payment initialized successfully');
            return card;
        }

        // Handle payment form submission
        async function handlePaymentSubmit(event) {
            event.preventDefault();
            
            if (!card) {
                console.error('Payment form not initialized');
                return;
            }

            const payButton = qs(stepPayment, '#payButton');
            const statusContainer = qs(stepPayment, '#payment-status-container');
            
            // Disable button to prevent double submission
            payButton.disabled = true;
            payButton.textContent = 'Processing...';
            
            try {
                // Tokenize card
                const result = await card.tokenize();
                
                if (result.status === 'OK') {
                    console.log('Payment token received:', result.token);
                    
                    // Add token to form
                    const paymentForm = qs(stepPayment, '#paymentForm');
                    if (paymentForm) {
                        // Remove existing token input if any
                        const existingToken = paymentForm.querySelector('input[name="payment_token"]');
                        if (existingToken) existingToken.remove();
                        
                        // Add new token input
                        const tokenInput = document.createElement('input');
                        tokenInput.type = 'hidden';
                        tokenInput.name = 'payment_token';
                        tokenInput.value = result.token;
                        paymentForm.appendChild(tokenInput);
                        
                        // Submit form
                        paymentForm.submit();
                    } else {
                        console.error('Payment form not found');
                        payButton.disabled = false;
                        payButton.textContent = 'Submit';
                    }
                } else {
                    // Handle tokenization errors
                    let errorMessage = 'Payment failed. Please check your card details.';
                    
                    if (result.errors) {
                        errorMessage = result.errors.map(error => error.message).join(', ');
                    }
                    
                    console.error('Tokenization failed:', result.errors);
                    statusContainer.innerHTML = `<div class="alert alert-danger">${errorMessage}</div>`;
                    
                    // Re-enable button
                    payButton.disabled = false;
                    payButton.textContent = 'Submit';
                }
            } catch (error) {
                console.error('Payment error:', error);
                statusContainer.innerHTML = `<div class="alert alert-danger">Payment processing failed. Please try again.</div>`;
                
                // Re-enable button
                payButton.disabled = false;
                payButton.textContent = 'Submit';
            }
        }
        
        // Initialize payment when step becomes visible - запускається лише 1 раз
        const initPaymentOnShow = async () => {
            // Перевіряємо чи вже ініціалізовано АБО зараз ініціалізується
            if (isPaymentInitialized || isPaymentInitializing) {
                console.log('Payment already initialized or initializing, skipping...');
                return;
            }

            
            console.log('Starting payment initialization...');
            isPaymentInitializing = true; // Встановлюємо флаг що ініціалізація почалась

               // if we do not have <meta name="csrf_token"> in the page, the request will fail, so we simulate  loading state for local testing 
                const csrfTokenMeta = document.querySelector('meta[name="csrf_token"]');
                if (!csrfTokenMeta) {
                    console.log('Simulating payment initialization (no CSRF token found).');
                    await new Promise((resolve) => setTimeout(resolve, 1000));
                    isPaymentInitialized = true;
                    isPaymentInitializing = false;
                    console.log('Payment initialization simulated successfully');

                    // add test submit button handler that bypasses payment for easier testing
                    const testSubmitBtn = qs(stepPayment, '#testSubmitButton');
                    if (testSubmitBtn) {
                        testSubmitBtn.addEventListener('click', (e) => {
                            e.preventDefault();
                            console.log('Test submit button clicked, bypassing payment...');
                            // go to susccess page
                            window.location.href = '/success.html';
                        });
                    }
                    return;
                }

            // add test submit button handler that bypasses payment for easier testing
            const testSubmitBtn = qs(stepPayment, '#testSubmitButton');
            if (testSubmitBtn) {
                testSubmitBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    console.log('Test submit button clicked, bypassing payment...');
                    const paymentForm = qs(stepPayment, '#paymentForm');
                    if (paymentForm) {
                        // Add hidden input to indicate test submission
                        const testInput = document.createElement('input');
                        testInput.type = 'hidden';
                        testInput.name = 'test_submission';
                        testInput.value = '1';
                        paymentForm.appendChild(testInput);
                        paymentForm.submit();
                    } else {
                        console.error('Payment form not found for test submission');
                    }
                });
            }
            
            
            try {
                await initSquarePayment();
                
                // Attach submit handler лише якщо ще не прикріплений
                const payButton = qs(stepPayment, '#payButton');
                if (payButton && !payButton._squareHandlerAttached) {
                    payButton.addEventListener('click', handlePaymentSubmit);
                    payButton._squareHandlerAttached = true; // Позначаємо що обробник вже прикріплений
                }
                
                isPaymentInitialized = true; // Успішно ініціалізовано
                console.log('Payment system initialized successfully');
            } catch (error) {
                console.error('Failed to initialize payment:', error);
                alert('Failed to load payment system. Please refresh and try again.');
                const paymentLoader = qs(stepPayment, '#paymentLoader');
                    if (paymentLoader) {
                        paymentLoader.style.color = 'red';
                        paymentLoader.textContent = 'Failed to load payment system. Please refresh and try again.';
                    }
            } finally {
                isPaymentInitializing = false; // Знімаємо флаг ініціалізації
            }
        };
        
        initPaymentOnShow();
}

export function initWorkflow (container, {
    hiddenClass = CFG.classes.hidden,
    patientDropdownId = CFG.ids.patientDd,
    errorClass = CFG.classes.error
} = {}) {
    const stepOption = qs(container, '[data-option]');
    const stepCal = qs(container, '[data-calendar]');
    const stepClient = qs(container, '[data-client-info]');
    const stepPayment = qs(container, '[data-payment]');

    const steps = [stepOption, stepCal, stepClient, stepPayment].filter(Boolean);
    let lastBookBtn = null;

    const ensureDateSelected = () => {
        const calEl = qs(container, CFG.selectors.calendar);
        const dp = calEl?._airdp;
        if (!dp) return;
        const hasDate = Array.isArray(dp.selectedDates) && dp.selectedDates.length > 0;
        if (!hasDate) {
            const fallback = dp.viewDate || new Date();
            dp.selectDate(fallback);
        }
        const d = dp?.selectedDates?.[0];
        if (d) state.dateISO = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())).toISOString().slice(0, 10);
    };

    const showOnly = (el) => {
        steps.forEach(s => s?.classList.add(hiddenClass));
        el?.classList.remove(hiddenClass);
        el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    showOnly(stepOption);
    if (stepOption) {
        console.log('Initialize option step... bindBookButtonsValidation');

        // init click on verifyMilID button to recalc prices
        const verifyMilIDBtn = qs(container, '#verifyMilID');
        if (verifyMilIDBtn) {
            // Remove any existing event listener to prevent duplicates
            if (verifyMilIDBtn._verifyHandler) {
                verifyMilIDBtn.removeEventListener('click', verifyMilIDBtn._verifyHandler);
            }
            
            // Create new handler function
            const verifyHandler = (e) => {
                e.preventDefault();
                console.log('verifyMilID clicked, starting verification...');
                
                // Get military ID value
                let milIDInput = qs(container, '#milIDInput');
                let milID = milIDInput ? milIDInput.value.trim() : '';
                
                if (!milID) {
                    showAlert('Please enter your Military ID', 'error');
                    return;
                }
                
                // Disable button and show loading state
                verifyMilIDBtn.disabled = true;
                showLoading(verifyMilIDBtn, 'loading');
                
                // Use the refactored API function
                verifyMilID(milID)
                    .then(data => {
                        console.log('Military ID verification response:', data);
                        
                        // Re-enable button and hide loading
                        verifyMilIDBtn.disabled = false;
                        hideLoading(verifyMilIDBtn, 'loading');
                        
                        // Check if verification was successful
                        if (data.success === true && data.valid === true) {
                            console.log('Military ID is valid:', data);
                            showAlert(data.message || 'Military ID verified successfully!', 'success');
                            
                            // Update state
                            state.isVeteran = true;
                            state.veteranID = data.format || milID;
                            state.veteranVerified = true;
                            
                            // Visual feedback - mark input as valid
                            if (milIDInput) {
                                milIDInput.classList.remove('is-invalid');
                                milIDInput.classList.add('is-valid');
                            }
                            
                            // Trigger price recalculation
                            container.dispatchEvent(new Event('veteran-upload:changed'));
                            
                        } else {
                            // Verification failed or invalid
                            console.log('Military ID is invalid:', data);
                            const errorMsg = data.error || data.message || 'Military ID verification failed';
                            showAlert(errorMsg, 'error');
                            
                            // Update state
                            state.isVeteran = false;
                            state.veteranID = null;
                            state.veteranVerified = false;
                            
                            // Visual feedback - mark input as invalid
                            if (milIDInput) {
                                milIDInput.classList.remove('is-valid');
                                milIDInput.classList.add('is-invalid');
                            }
                            
                            // Still trigger price recalculation to remove veteran pricing
                            container.dispatchEvent(new Event('veteran-upload:changed'));
                        }
                    })
                    .catch(error => {
                        console.error('Error verifying Military ID:', error);
                        
                        // Re-enable button and hide loading
                        verifyMilIDBtn.disabled = false;
                        hideLoading(verifyMilIDBtn, 'loading');
                        
                        // Determine error message
                        let errorMessage = 'Military ID verification failed. Please try again.';
                        
                        // Try to extract error from different possible response formats
                        if (error && typeof error === 'object') {
                            if (error.responseJSON && error.responseJSON.error) {
                                errorMessage = error.responseJSON.error;
                            } else if (error.error) {
                                errorMessage = error.error;
                            } else if (error.message) {
                                errorMessage = error.message;
                            } else if (error.responseText) {
                                try {
                                    const errorData = JSON.parse(error.responseText);
                                    errorMessage = errorData.error || errorData.message || errorMessage;
                                } catch (parseError) {
                                    console.warn('Could not parse error response:', parseError);
                                }
                            }
                        }
                        
                        showAlert(errorMessage, 'error');
                        
                        // Update state to non-veteran on error
                        state.isVeteran = false;
                        state.veteranID = null;
                        state.veteranVerified = false;
                        
                        // Visual feedback - mark input as invalid
                        if (milIDInput) {
                            milIDInput.classList.remove('is-valid');
                            milIDInput.classList.add('is-invalid');
                        }
                        
                        // Trigger price recalculation
                        container.dispatchEvent(new Event('veteran-upload:changed'));
                    });
            };
            
            // Store reference to the handler for future removal
            verifyMilIDBtn._verifyHandler = verifyHandler;
            
            // Add new event listener
            verifyMilIDBtn.addEventListener('click', verifyHandler);
        }

        // verifyEmail button handler
        const verifyEmailBtn = qs(container, '#verifyEmail');
        // on change of email input remove error/valid classes
        const emailInput = qs(container, 'input[name="emailToVerify"]');
        if (emailInput) {
            emailInput.addEventListener('input', () => {
                emailInput.classList.remove('error');
                emailInput.classList.remove('valid');
            });
        }
        if (verifyEmailBtn) {
            // Remove any existing event listener to prevent duplicates
            if (verifyEmailBtn._emailVerifyHandler) {
                verifyEmailBtn.removeEventListener('click', verifyEmailBtn._emailVerifyHandler);
            }
            
            // Create new handler function
            const emailVerifyHandler = (e) => {
                e.preventDefault();
                const emailInput = qs(container, 'input[name="emailToVerify"]');
                const wrapper = qs(container, '.book__optionReturn');
                const email = emailInput ? emailInput.value.trim() : '';
                if (!email) {
                    emailInput.classList.add('error');
                    return;
                }
                // Simple email format validation
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(email)) {
                    emailInput.classList.add('error');
                    return;
                }
                console.log('Email to verify:', email);
                // gev status from backend api
                checkEmailExists(email).then(data => {
                    console.log('Email verification response:', data);
                    if (data.exists) {
                        //showAlert('Email verified successfully!', 'success');
                        // add book__option--success class to wrapper
                        emailInput.classList.remove('error');
                        wrapper.classList.add('book__option--success');
                        state.isReturningPatient = true;
                    } else {
                        //showAlert('Email not found. Please check and try again.', 'error');
                        emailInput.classList.add('error');
                        wrapper.classList.remove('book__option--success');
                        state.isReturningPatient = false;
                    }
                }).catch(err => {
                    console.error('Error verifying email:', err);
                    emailInput.classList.add('error');
                    wrapper.classList.remove('book__option--success');
                    //showAlert('Error verifying email. Please try again later.', 'error');
                });
            };
            
            // Store reference to the handler for future removal
            verifyEmailBtn._emailVerifyHandler = emailVerifyHandler;
            
            // Add new event listener
            verifyEmailBtn.addEventListener('click', emailVerifyHandler);
        }                


        bindBookButtonsValidation(container, {
            errorClass,
            patientDropdownId,
            onSuccess ({ trigger }) {
                console.log('Choose day and time step...');
                const calendarSelector = CFG.selectors.calendar;
                const datepickerOptions = {};
                initCalendar(container, { calendarSelector, AirDatepicker, localeEn, datepickerOptions });
                lastBookBtn = trigger || null;
                state.plan = state.plan || (lastBookBtn ? getPlanNameByTrigger(lastBookBtn) : null);
                showOnly(stepCal);
                ensureDateSelected();
                
            }
        });
    }

    if (stepCal) {
        const radios = qsa(stepCal, '.book__calendarItems input[type="radio"]');

        initClickTimeSlots(container, radios);

        const backBtn = qs(stepCal, '.back-btn');
        backBtn?.addEventListener('click', (e) => { e.preventDefault(); showOnly(stepOption); });

        container.addEventListener('calendar:changed', () => {
            const calEl = qs(container, CFG.selectors.calendar);
            const dp = calEl?._airdp;
            const d = dp?.selectedDates?.[0];
            state.dateISO = d ? new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())).toISOString().slice(0, 10) : null;

            console.log('calendar:changed', state.dateISO);

            
        });
    }

    bindClientFormValidation(container, {
        errorClass,
        onSuccess () {
            fillPaymentSummary(container, { triggerBtnForPlan: lastBookBtn });
            showOnly(stepPayment);
        }
    });

    if (stepClient) {
        const backBtn = qs(stepClient, '.back-btn');
        backBtn?.addEventListener('click', (e) => { e.preventDefault(); showOnly(stepCal); });
    }

    if (stepPayment) {
        const backBtn = qs(stepPayment, '.back-btn');
        
        

        backBtn?.addEventListener('click', (e) => { e.preventDefault(); showOnly(stepClient); });


        const recalcIfOnPayment = () => {
            if (!stepPayment.classList.contains(hiddenClass)) {
                fillPaymentSummary(container, { triggerBtnForPlan: lastBookBtn });
            }
        };

        //container.addEventListener('veteran-upload:changed', recalcIfOnPayment);
        container.addEventListener('summary:recalc', recalcIfOnPayment);
        container.addEventListener('calendar:changed', recalcIfOnPayment);

        qsa(container, '.book__calendarItems input[type="radio"]').forEach(r =>
            r.addEventListener('change', recalcIfOnPayment)
        );
    }
}
